import React from "react"

export interface FieldControlProps {
  "aria-invalid": boolean
  "aria-describedby": string | undefined
}

interface FieldProps {
  name: string
  label: string
  error?: string
  children: (controlProps: FieldControlProps) => React.ReactNode
}

// A form list item, styled like legacy formtastic: label, control and inline server error.
export default function Field({ name, label, error, children }: FieldProps) {
  "use memo"

  const errorId = `${name}-inline-error`

  return (
    <li className="pt-6 pb-1.5">
      <label htmlFor={name} className="max-md:text-2xs block py-1.5 leading-4.5">
        {label}
      </label>
      {children({
        "aria-invalid": Boolean(error),
        "aria-describedby": error ? errorId : undefined,
      })}
      {error && (
        <p
          id={errorId}
          className="text-2xs my-1.5 max-w-150 leading-3 font-bold text-red-500 first-letter:uppercase"
        >
          {error}
        </p>
      )}
    </li>
  )
}
